import React from 'react';
import bg from '../../images/about/about-bg.png';

function About() {
  return (
    <div className="relative overflow-hidden aboutus min-h-0">
      {/* Background */}
      <div className="absolute inset-0">
        <div 
          className="w-full h-full bg-cover bg-center bg-no-repeat" 
          style={{ backgroundImage: `url(${bg})` }}
        ></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-2 py-4">
        
        {/* Title Section */}
        <div className="text-center mb-2">
          <h1 className="text-xs font-semibold text-black">
            കേരള സാർവദേശീയ സാഹിത്യോത്സവം
          </h1>
        </div>

        {/* Content Section */}
        <div className="space-y-3">
          
          {/* Malayalam Text Block */}
          <div className="max-w-full">
            <p className="text-xs leading-4 text-black font-normal">
              കേരള സാഹിത്യ അക്കാദമിയുടെയും കേരള സർക്കാർ സാംസ്കാരികവകുപ്പിന്റെയും
              ആഭിമുഖ്യത്തിൽ സംഘടിപ്പിക്കുന്ന സാർവദേശീയ സാഹിത്യോത്സവം അതിന്റെ
              രണ്ടാം പതിപ്പിലേക്കു കടക്കുകയാണ്. പൂർണമായ അർത്ഥത്തിൽ ജനങ്ങളുടെ
              സാഹിത്യോത്സവമാണിത്. എഴുത്തുകാരും ചിന്തകരും വായനക്കാരും ഒന്നിക്കുന്ന
              ഈ ഉത്സവം അവതരണങ്ങളും ചർച്ചകളും ശില്പശാലകളും പ്രഭാഷണങ്ങളും കൊണ്ടു
              സമ്പന്നമാകുന്നു. ജനാധിപത്യത്തിനും സാംസ്കാരികസംവാദങ്ങൾക്കും
              വേദിയൊരുക്കുന്ന ഈ സാഹിത്യോത്സവത്തിന്റെ പുതിയ പതിപ്പിലേക്കു സ്വാഗതം.
            </p>
          </div>

          {/* English Text Block */}
          <div className="max-w-full">
            <p className="text-xs leading-4 text-black font-normal">
              The International Literature Festival of Kerala (ILFK), now in its second
              edition, is organized by Kerala Sahitya Akademi and the Department of
              Culture, Government of Kerala. It is a true people's festival that
              celebrates the power of literature to connect, question, and inspire.
              Set in the culturally vibrant landscape of Kerala, ILFK brings together
              writers, artists, thinkers, and readers from across the globe for a rich
              tapestry of conversations, performances, readings, and workshops. With a
              strong commitment to inclusivity and cultural dialogue, the festival
              offers a dynamic space where diverse voices meet and literature becomes a
              shared, living experience for all.
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default About;
